// import React from "react";
// import { motion } from "framer-motion";
// import { Download, Upload } from "lucide-react";

// export default function DataTableCard({
//   title,
//   subtitle,
//   columns = [],
//   rows = [],
//   actions,
// }) {
//   return (
//     <motion.section
//       className="erp-card"
//       initial={{ opacity: 0, y: 18 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3 }}
//     >
//       <div className="erp-card-head">
//         <div>
//           <h3>{title}</h3>
//           <p>{subtitle}</p>
//         </div>
//         <div className="erp-inline-actions">
//           {actions || (
//             <>
//               {/* <motion.button
//                 type="button"
//                 className="erp-btn erp-btn-ghost"
//                 whileTap={{ scale: 0.97 }}
//               >
//                 <Upload size={15} /> Import
//               </motion.button> */}
//               {/* <motion.button
//                 type="button"
//                 className="erp-btn erp-btn-primary"
//                 whileTap={{ scale: 0.97 }}
//               >
//                 <Download size={15} /> Export
//               </motion.button> */}
//             </>
//           )}
//         </div>
//       </div>

//       <div className="erp-table-wrap">
//         <table className="erp-table">
//           <thead>
//             <tr>
//               {columns.map((col) => (
//                 <th key={col.key}>{col.label}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {rows.length ? (
//               rows.map((row, idx) => (
//                 <motion.tr
//                   key={idx}
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: idx * 0.03 }}
//                 >
//                   {columns.map((col) => (
//                     <td key={col.key}>{row[col.key]}</td>
//                   ))}
//                 </motion.tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={columns.length || 1} className="erp-empty-cell">
//                   No data available yet
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </motion.section>
//   );
// }


import React from "react";
import { motion } from "framer-motion";
import { Download, Upload } from "lucide-react";

export default function DataTableCard({
  title,
  subtitle,
  columns = [],
  rows = [],
  actions,
}) {
  return (
    <motion.section
      className="erp-card"
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="erp-card-head">
        <div>
          <h3>{title}</h3>
          <p>{subtitle}</p>
        </div>

        <div className="erp-inline-actions">
          {actions || (
            <>
              {/* Import / Export */}
            </>
          )}
        </div>
      </div>

      <div className="erp-table-wrap">
        <table className="erp-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.length ? (
              rows.map((row, idx) => (
                <motion.tr
                  key={idx}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: idx * 0.03 }}
                >
                  {columns.map((col) => (
                    <td key={col.key}>
                      {col.render
                        ? col.render(row, idx)
                        : row[col.key]}
                    </td>
                  ))}
                </motion.tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length || 1}
                  className="erp-empty-cell"
                >
                  No data available yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </motion.section>
  );
}